// ELECTRIC WITCH — ATC BUTTON
// Size gate REMOVED 22 Aug 2026. Theme now pre-selects the first available
// variant natively (Shopify default), so the button is live on page load.
// This module: mirrors the live variant price into the Add to Cart button
// and keeps the press feedback animation.
(function () {
  const SECTION_SEL = ".shopify-section--main-product";

  // The price now also sits on its own row above the sizes. Set this to false
  // to show it ONLY in the sticky bar button and drop it from the main button,
  // which is how the reference site handles it.
  const PRICE_IN_MAIN_BUTTON = true;
  const BUTTON_SEL =
    SECTION_SEL + ' .product-info__buy-buttons button[type="submit"], ' +
    '.product-quick-add buy-buttons button[type="submit"]';
  const PRICE_SEL = SECTION_SEL + " .product-info__price sale-price";

  // Collapse an exactly-repeated string: "$59 AUD$59 AUD$59 AUD" -> "$59 AUD".
  function collapseRepeats(str) {
    for (let size = 1; size <= str.length / 2; size++) {
      if (str.length % size !== 0) continue;
      if (str.slice(0, size).repeat(str.length / size) === str) {
        return str.slice(0, size);
      }
    }
    return str;
  }

  // Last price-like token, for when the repeats aren't identical
  // (e.g. "$59 AUD$65 AUD" after switching to a dearer size -> "$65 AUD").
  const PRICE_TOKEN = /[^\s\d]*\s?\d[\d.,]*(?:\s?[A-Za-z]{3})?/g;

  function lastPriceToken(str) {
    const matches = str.match(PRICE_TOKEN);
    if (!matches || !matches.length) return str;
    return matches[matches.length - 1].trim();
  }

  // Read the rendered price, minus the screen-reader label.
  // Reading the DOM (not variant.price) keeps Markets currency correct.
  //
  // The theme concatenates each new price into the SAME text node rather than
  // replacing it, so <sale-price> reads "$59 AUD$59 AUD$59 AUD" after a few
  // variant changes. Invisible to customers (the block is hidden by CSS) but
  // we have to undo it before mirroring into the button.
  function readPrice(el) {
    const clone = el.cloneNode(true);
    clone.querySelectorAll(".sr-only, .visually-hidden").forEach((n) => n.remove());

    let text = (clone.textContent || "").replace(/\s+/g, " ").trim();
    if (!text) return "";

    text = collapseRepeats(text);

    // Still more than one price in there? Take the most recent.
    const tokens = text.match(PRICE_TOKEN);
    if (tokens && tokens.length > 1) text = lastPriceToken(text);

    return text.trim();
  }

  function boot() {
    const buttons = Array.from(document.querySelectorAll(BUTTON_SEL));
    const priceEl = document.querySelector(PRICE_SEL);

    if (!buttons.length) return;
    if (!priceEl) {
      // The price block has been removed from the product template. Without it
      // there is no price to mirror — leave the button as the theme rendered it.
      console.warn(
        "EW ATC: no price element found (" + PRICE_SEL + "). " +
        "Re-add the Price block to the product template — it can stay hidden, " +
        "the CSS hides it, but the block must exist for the button price to work."
      );
      return;
    }

    buttons.forEach((button) => {
      const isSticky = !!button.closest(".product-quick-add");
      if (!isSticky && !PRICE_IN_MAIN_BUTTON) return;
      attach(button, priceEl);
    });
  }

  function attach(button, priceEl) {
    button.classList.add("ew-atc");

    let priceSpan = button.querySelector(".ew-atc-price");
    if (!priceSpan) {
      priceSpan = document.createElement("span");
      priceSpan.className = "ew-atc-price";
      priceSpan.setAttribute("aria-hidden", "true"); // price is already announced by the price block
      button.appendChild(priceSpan);
    }

    let syncing = false;
    function sync() {
      if (syncing) return;
      syncing = true;
      try {
        update();
      } finally {
        syncing = false;
      }
    }

    function update() {

      // if a theme re-render detached our span, put it back
      if (!priceSpan.isConnected) button.appendChild(priceSpan);

      const text = readPrice(priceEl);
      if (priceSpan.textContent !== text) priceSpan.textContent = text;

      // hide the price when sold out / unavailable
      const show = !!text && !button.disabled;
      if (button.classList.contains("ew-atc--has-price") !== show) {
        button.classList.toggle("ew-atc--has-price", show);
      }

    }

    sync();

    // sale-price re-renders its text node on variant:change
    new MutationObserver(sync).observe(priceEl, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["class"],
    });

    // catch sold-out / unavailable flips
    new MutationObserver(sync).observe(button, {
      attributes: true,
      attributeFilter: ["disabled"],
    });

    // ---- press feedback (unchanged behaviour, gate removed) ----
    const form = button.closest("form");
    if (form && !form.dataset.ewAtcFeedback) {
      form.dataset.ewAtcFeedback = "1";
      button.addEventListener("click", () => {
        form.classList.add("ew-atc-feedback");
        setTimeout(() => {
          form.classList.remove("ew-atc-feedback");
          form.classList.add("ew-atc-feedback-return");
        }, 120);
        setTimeout(() => form.classList.remove("ew-atc-feedback-return"), 300);
      });
    }
  }

  // Wait for the theme's <button is="custom-button"> upgrade before appending,
  // otherwise CustomButton swallows our span into its content wrapper.
  function start() {
    const ready = window.customElements
      ? window.customElements.whenDefined("custom-button")
      : Promise.resolve();
    Promise.race([ready, new Promise((r) => setTimeout(r, 2000))]).then(() =>
      requestAnimationFrame(boot)
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  // theme editor re-renders
  document.addEventListener("shopify:section:load", start);
})();





// ELECTRIC WITCH — REVIEWS + SIZE GUIDE ROW
// Puts a size-guide trigger on the same line as the review badge, hard right.
//
// IMPORTANT — why this proxies instead of moving Kiwi's link:
// Kiwi binds its click via event DELEGATION on an ancestor container, not on
// the link itself. Relocating the link therefore moves it out of the container
// that is listening, and the click silently stops working (learned the hard
// way). So Kiwi's link stays exactly where it is, visually hidden but still in
// the DOM and still inside its delegate parent. Our own button forwards the
// click to it with .click(), which bubbles and fires their delegated handler.
(function () {
  const LABEL = /^(view\s+)?size\s*(guide|chart)$/i;
  const STYLE_ID = "ew-meta-row-styles";

  // Type EW_PDP_DIAG in the console to see what this found.
  window.EW_PDP_VERSION = "meta-row-5";
  window.EW_PDP_DIAG = { rating: "not run", guide: "not run", proxied: false, hidWrapper: null };

  const CSS = `
    .ew-meta-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: var(--spacing-4, 16px);
      width: 100%;
      flex-wrap: nowrap;
    }
    .ew-meta-row > .ew-meta-row__rating { flex: 0 1 auto; min-width: 0; margin: 0; }
    .ew-meta-row__guide {
      flex: 0 0 auto;
      margin: 0 0 0 auto;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      font-family: inherit;
      font-size: 13px;
      font-weight: 700;
      letter-spacing: 0.4px;
      text-transform: uppercase;
      color: #767676;
      text-decoration: none;
      border: none;
      background: none;
      padding: 0;
      cursor: pointer;
      white-space: nowrap;
    }
    .ew-meta-row__guide:hover { color: #000; text-decoration: underline; }
    .ew-meta-row__guide .ew-sg-icon { width: 14px; height: 14px; flex-shrink: 0; }
    /* Kiwi's own link: kept in the DOM so its delegated handler still works,
       but taken out of the layout. Not display:none — some widgets check it. */
    .ew-kiwi-source-hidden {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      padding: 0 !important;
      margin: -1px !important;
      overflow: hidden !important;
      clip: rect(0 0 0 0) !important;
      white-space: nowrap !important;
      border: 0 !important;
    }
    @media (max-width: 640px) {
      .ew-meta-row__guide { font-size: 11px; letter-spacing: 0.2px; }
      .ew-meta-row__guide .ew-sg-icon { width: 12px; height: 12px; }
    }
  `;

  const RULER =
    '<svg class="ew-sg-icon" viewBox="0 0 16 16" fill="none" ' +
    'xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M1 10.5 10.5 1 15 5.5 5.5 15 1 10.5Z" stroke="currentColor" ' +
    'stroke-width="1.3" stroke-linejoin="round"/>' +
    '<path d="M4 7.5 5.5 9M6.5 5 8 6.5M9 2.5 10.5 4" stroke="currentColor" ' +
    'stroke-width="1.3" stroke-linecap="round"/></svg>';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const tag = document.createElement("style");
    tag.id = STYLE_ID;
    tag.textContent = CSS;
    document.head.appendChild(tag);
  }

  function findGuide(scope) {
    let best = null;
    for (const el of scope.querySelectorAll("*")) {
      if (el.closest(".ew-meta-row")) continue;
      if (el.classList.contains("ew-kiwi-source-hidden")) continue;
      if (!LABEL.test((el.textContent || "").trim())) continue;
      if (!best || best.contains(el)) best = el;
    }
    if (best) {
      const clickable = best.closest("a, button, [role='button'], [onclick]");
      if (clickable && LABEL.test((clickable.textContent || "").trim())) return clickable;
    }
    return best;
  }

  function findRating(info) {
    for (const child of info.children) {
      if (child.matches('[class*="jdgm"]') || child.querySelector('[class*="jdgm"]')) {
        return child;
      }
    }
    return null;
  }

  function boot() {
    const section = document.querySelector(".shopify-section--main-product");
    const info = section && section.querySelector(".product-info");
    if (!info) return;

    if (info.querySelector(".ew-meta-row__guide")) return; // done

    const rating = info.querySelector(".ew-meta-row__rating") || findRating(info);
    if (!rating) { window.EW_PDP_DIAG.rating = "NOT FOUND"; return; }
    window.EW_PDP_DIAG.rating = "found";

    const source = findGuide(section);
    if (!source) { window.EW_PDP_DIAG.guide = "NOT FOUND"; return; }
    window.EW_PDP_DIAG.guide = source.tagName + "." + (source.className || "(no class)");

    injectStyles();

    let row = info.querySelector(".ew-meta-row");
    if (!row) {
      row = document.createElement("div");
      row.className = "ew-meta-row";
      rating.before(row);
      rating.classList.add("ew-meta-row__rating");
      row.appendChild(rating);
    }

    // our trigger
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "ew-meta-row__guide";
    btn.innerHTML = RULER + "<span>Size Guide</span>";
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      source.click(); // bubbles, so Kiwi's delegated listener fires
    });
    row.appendChild(btn);

    // Hide Kiwi's link in place. The link STAYS in the DOM (its delegated
    // handler depends on that), so its wrapper is not empty afterwards —
    // hide the whole wrapper instead, as long as the size guide is the only
    // thing in it. Otherwise the wrapper keeps its row and leaves a gap,
    // because the theme margins every direct child of .product-info.
    source.classList.add("ew-kiwi-source-hidden");

    let node = source;
    while (node && node.parentElement && node.parentElement !== info) {
      node = node.parentElement;

      const onlyHoldsGuide = LABEL.test((node.textContent || "").trim());
      const isSafe =
        node !== row &&
        !node.contains(row) &&
        !node.querySelector("img, iframe, input, select");

      if (onlyHoldsGuide && isSafe) {
        node.classList.add("ew-kiwi-source-hidden");
        window.EW_PDP_DIAG.hidWrapper =
          node.tagName + "." + (node.className || "(no class)");
      }
    }

    window.EW_PDP_DIAG.proxied = true;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  let tries = 0;
  const poll = setInterval(() => {
    boot();
    if (++tries > 30) clearInterval(poll);
  }, 250);

  document.addEventListener("shopify:section:load", boot);
})();


// ---------------------------------------------------------------------
// Tee bundle progress bar — REMOVED 26 Aug 2026.
//
// It hard-coded the old ladder (2 tees = 20% off, 4 tees = 35% off), which
// expired 16 Feb 2026, and it overwrote the cart bar's message with that dead
// offer on every cart update. It also counted only product_type "t-shirt",
// while Buy 3 Get 1 Free applies to the whole Shop All collection.
//
// The bar now lives entirely in snippets/tshirt-progress-bar.liquid, which
// renders server-side and carries its own inline script. Do not re-add a
// second script here — two scripts fighting over [data-tee-message] is
// exactly what broke it.
// ---------------------------------------------------------------------
